import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		isIOS: /(iPhone|iPad)/gi.test(navigator.userAgent),
		isAndroid: /(Android)/gi.test(navigator.userAgent),
		isIE: /(MSIE|Trident)/gi.test(navigator.userAgent),
		isWindows: navigator.platform.indexOf('Win') > -1,
		countryCode: '',
		gameList: [],
		heroBannerList: [],
		mediaList: [],
		config: null,
	},
	actions: {
		getCountryCode({ commit, state }) {
			if (state.countryCode) return state.countryCode;
			return this._vm.$coreAPI.getCountryCode().then((countryCode) => commit('setCountryCode', countryCode));
		},
		async getHeroBannerList({ dispatch, commit, state }) {
			if (state.heroBannerList.length > 0) return state.heroBannerList;
			await dispatch('getCountryCode');
			this._vm.$cdnAPI.getHeroBannerList(state.countryCode).then((heroBannerList) => {
				commit('setHeroBannerList', heroBannerList);
				return heroBannerList;
			});
		},
		async getGameList({ dispatch, commit, state }) {
			if (state.gameList.length > 0) return state.gameList;
			await dispatch('getCountryCode');
			return this._vm.$cdnAPI.getGameList(state.countryCode).then((gameList) => {
				commit('setGameList', gameList);
				return gameList;
			});
		},
		async getMediaList({ dispatch, commit, state }) {
			if (state.mediaList.length > 0) return state.mediaList;
			await dispatch('getCountryCode');
			return this._vm.$cdnAPI.getMediaList(state.countryCode).then((mediaList) => commit('setMediaList', mediaList));
		},
		async getConfig({ dispatch, commit, state }) {
			if (state.config !== null) return state.config;
			await dispatch('getCountryCode');
			return this._vm.$cdnAPI.getFrontendConfig(state.countryCode).then((config) => commit('setConfig', config));
		},
	},
	mutations: {
		setCountryCode(state, payload) {
			state.countryCode = payload;
		},
		setGameList(state, payload) {
			state.gameList = payload;
		},
		setHeroBannerList(state, payload) {
			state.heroBannerList = payload;
		},
		setMediaList(state, payload) {
			state.mediaList = payload;
		},
		setConfig(state, payload) {
			state.config = payload;
		},
	},
});
